/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';
import _ from 'underscore';

import BenchlingConfig from 'BenchlingConfig';
import {StandardFeature} from 'auth/capabilities/CapabilityConstants';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import {REGISTRY_TYPE} from 'constants/SourceConstants';
import FileBrowserActions from 'file-browser/FileBrowserActions';
import FolderDAOCache from 'file-browser/FolderDAOCache';
import FolderDefaults, {FolderDefaultsKey} from 'FolderDefaults';
import notifications from 'notifications';
import * as popup from 'Popup';
import * as RegistryUtil from 'registry/RegistryUtil';
import {capitalize, capwords, typeToName} from 'util/NameUtil';

import ReactPanelBaseView from '../ReactPanelBaseView';
import InformationSubpanel from './InformationSubpanel';
import TagsSubpanel from './TagsSubpanel';

class BasicInformationPanelView extends ReactPanelBaseView {
  friendlyFileType() {
    return typeToName(this.model.fileState().fileType());
  }

  folderDefaultsKey() {
    return FolderDefaultsKey.INVENTORY;
  }

  initialize() {
    super.initialize();
    this.deleteModal = this.deleteModal.bind(this);
    this.deleteModel = this.deleteModel.bind(this);
    this._saveModelIfNeededAndNotifySuccess = this._saveModelIfNeededAndNotifySuccess.bind(this);
    this.saveChangesToModel = this.saveChangesToModel.bind(this);
    this.saveModel = this.saveModel.bind(this);
    this.onSaveSuccess = this.onSaveSuccess.bind(this);
    this.onDeleteSuccess = this.onDeleteSuccess.bind(this);
  }

  deleteModal() {
    new popup.Confirm({
      title: `Delete ${capwords(this.friendlyFileType())}`,
      msg: `Are you sure you want to delete the ${this.friendlyFileType()}? It cannot be recovered.`,
    })
      .choice('Cancel', 'btn-af-default')
      .choice('Delete', 'btn-af-danger', this.deleteModel)
      .show();
  }

  deleteModel() {
    this.model.destroy().fail(notifications.notifyError).done(this.onDeleteSuccess);
  }

  _saveModelIfNeededAndNotifySuccess(data) {
    if (_.isEmpty(data)) {
      this.onSaveSuccess();
    } else {
      this.saveModel(data);
    }
  }

  async saveChangesToModel(name, folderId, tagSchemaId) {
    const fileId = this.model.id;
    const oldName = this.model.name();

    const data = {};
    if (this.model.folder()?.api_identifier !== folderId) {
      data.folder_id = folderId;
    }
    if (this.model.tagSchema()?.id !== tagSchemaId) {
      data.tagSchemaId = tagSchemaId;
    }

    if (oldName !== name) {
      try {
        await FileBrowserActions.renameFileWithDataMods(fileId, this.isRegistered(), {
          oldName,
          newName: name,
          notifyOnSuccess: false,
        });
        this._saveModelIfNeededAndNotifySuccess(data);
        // eslint-disable-next-line benchlint/always-throw-from-catch
      } catch (err) {
        notifications.notifyError(err);
      }
    } else {
      this._saveModelIfNeededAndNotifySuccess(data);
    }
  }

  // Saves the data to the model and calls @onSaveSuccess in case of success or displays
  // the error in case of an error
  saveModel(data) {
    this.model.save(data, {patch: true, wait: true}).fail(notifications.notifyError).done(this.onSaveSuccess);
  }

  onSaveSuccess() {
    notifications.success(`${capitalize(this.friendlyFileType())} successfully updated.`);
    if (this.model.fileState().isFolderItem()) {
      if (this.model.folder() != null && this.model.folder().source.sourceType !== REGISTRY_TYPE) {
        FolderDefaults.set(this.folderDefaultsKey(), this.model.folder().api_identifier);
      }
    }
    this.render();
  }

  onDeleteSuccess() {
    notifications.success(`${capitalize(this.friendlyFileType())} successfully deleted.`);
    FileBrowserActions.removeFromWorkspace(this.model.id);
    if (this.model.fileState().isFolderItem()) {
      FolderDAOCache.invalidateFolderContents(this.model.folder().api_identifier);
    }
  }

  getPermissions() {
    return this.model.permissions();
  }

  isRegistered() {
    return this.model.folder() != null && RegistryUtil.isRegistry(this.model.folder().source);
  }

  getSubpanels() {
    return _.compact([
      {
        key: 'information',
        title: 'Information',
        component: (
          <InformationSubpanel
            additionalPanelContent={
              typeof this.getAdditionalPanelContent === 'function'
                ? this.getAdditionalPanelContent()
                : undefined
            }
            archiveRecord={this.model.archiveRecord()}
            name={this.model.name()}
            folder={this.model.folder()}
            fileType={this.model.fileState().fileType()}
            friendlyFileType={this.friendlyFileType()}
            fileId={this.model.id}
            onClose={this.closePanel}
            permissions={this.getPermissions()}
            review={typeof this.model.review === 'function' ? this.model.review() : undefined}
            saveModel={this.saveChangesToModel}
            requestExport={this.requestExport}
            // Should return an object with fields "URL" and "title" if downloading is enabled.
            getDownloadInfo={this.getDownloadInfo}
            deleteModel={BenchlingConfig.ENABLE_DELETE ? this.deleteModal : undefined}
            showPatentsafeExport={this.showPatentsafeExport}
            thirdPartyStorageServiceData={
              typeof this.model.thirdPartyStorageServiceData === 'function'
                ? this.model.thirdPartyStorageServiceData()
                : undefined
            }
            currentTagSchema={this.model.tagSchema()}
          />
        ),
      },
      this.model.fileState().isFolderItem()
        ? {
            key: 'tags',
            title: 'Tags',
            component: (
              <TagsSubpanel
                id={this.model.id}
                allowEdits={
                  this.model.allowEdits() &&
                  isFeatureEnabled({
                    feature: StandardFeature.EDIT,
                    item: {id: this.model.id},
                    itemState: {isRegistered: this.isRegistered()},
                  })
                }
                tags={this.model.tags()}
                isRegistered={this.isRegistered()}
              />
            ),
          }
        : undefined,
    ]);
  }
}

// To enable testing of subcomponents
BasicInformationPanelView._InformationSubpanel = InformationSubpanel;

export default BasicInformationPanelView;
